import { IAdvertisementsListResponse } from '@/api/services/advertisements/advertisementsService'
import paths from '@/router/data/paths'
import { memo } from 'react'
import { Link } from 'react-router-dom'

function AdsList({ data }: { data: IAdvertisementsListResponse | undefined }) {
  if (!data) return null

  if (data.items.length === 0) {
    return (
      <div className="flex h-92 w-full items-center justify-center">
        <span className="text-2xl">Brak zapisanych grafik</span>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
      {data?.items.map((item) => (
        <Link
          className="flex flex-col justify-between gap-6 rounded-lg border border-border bg-white p-4"
          key={item.advertisement.id}
          to={paths.GRAPHICS_ID.replace(':id', item.advertisement.id)}
        >
          <div className="flex min-h-32 items-center justify-center rounded-md border border-border">
            {!item?.advertisement.resultImageFileId ? (
              <span className="">Brak zdjęcia</span>
            ) : (
              <img
                alt="Wygenerowana reklama"
                className="rounded-md object-contain"
                src={`${import.meta.env.VITE_API_URL}/api/v1/files/${item.advertisement.resultImageFileId}`}
              />
            )}
          </div>
          <div className="flex flex-col">
            {/* <p>Status: {item.generationStatus}</p> */}
            <p>Utworzono: {new Date(item.createdAt).toLocaleString()}</p>
          </div>
        </Link>
      ))}
    </div>
  )
}

export default memo(AdsList)
